import { FunctionComponent } from 'react';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { Checkbox } from '../../UI/V3/Forms/Checkbox/Checkbox';
import Button from '../../UI/V3/Button/Button';
import AlertMessage from '../../UI/V3/AlertMessage';
import { LocationCopyArea, LOCATION_COPY_AREAS } from '../../../model/location';
import styles from './DuplicateLocationModal.module.scss';

const NOT_INCLUDED =
    'Clients, pets, bookings, invoices, payments, payment processing setup, SMS phone number, email sender, Cuddles subscription and cameras.';

interface DuplicateLocationChecklistStepProps {
    areas: Array<LocationCopyArea>;
    isSubmitting: boolean;
    onToggleArea: (area: LocationCopyArea) => void;
    onToggleAll: () => void;
    onBack: () => void;
    onSubmit: () => void;
}

export const DuplicateLocationChecklistStep: FunctionComponent<DuplicateLocationChecklistStepProps> = ({
    areas,
    isSubmitting,
    onToggleArea,
    onToggleAll,
    onBack,
    onSubmit
}) => {
    const allSelected = areas.length === LOCATION_COPY_AREAS.length;

    return (
        <>
            <h2 className={styles.title}>What do you want to copy?</h2>
            <p className={styles.subtitle}>The selected configuration will be copied to the new location.</p>

            <div className={styles.checklistHeader}>
                <span className={styles.fieldLabel}>
                    {areas.length} of {LOCATION_COPY_AREAS.length} selected
                </span>
                <button
                    type="button"
                    className={styles.linkButton}
                    onClick={onToggleAll}
                    disabled={isSubmitting}
                >
                    {allSelected ? 'Clear all' : 'Select all'}
                </button>
            </div>

            <div className={styles.checklist}>
                {LOCATION_COPY_AREAS.map(area => (
                    <Checkbox
                        key={area.id}
                        className={styles.checklistItem}
                        label={area.label}
                        checked={areas.includes(area.id)}
                        onChange={() => onToggleArea(area.id)}
                    />
                ))}
            </div>

            <AlertMessage
                icon={faCircleInfo}
                bgColor="#F8F5F1"
                bdColor="#BCB8AE"
                iconColor="#BAA997"
                className={styles.neverCopied}
            >
                <span>
                    <span className={styles.neverCopiedLabel}>Not included in the copy:</span> {NOT_INCLUDED}
                </span>
            </AlertMessage>

            <div className={styles.actions}>
                <Button
                    label="Back"
                    variant="outlined"
                    size="large"
                    onClick={onBack}
                    disabled={isSubmitting}
                />
                <Button
                    label="Duplicate"
                    variant="black"
                    size="large"
                    isLoading={isSubmitting}
                    onClick={onSubmit}
                    disabled={isSubmitting || areas.length === 0}
                />
            </div>
        </>
    );
};

export default DuplicateLocationChecklistStep;
